import { AuthErrors } from '@appstrax/services/auth';

function extractErrorMessage(err: unknown): string {
  if (typeof err === 'string') return err;
  const anyErr = err as any;
  if (anyErr?.error && typeof anyErr.error === 'string') return anyErr.error;
  if (anyErr?.error?.message) return anyErr.error.message;
  if (anyErr?.error?.error?.message) return anyErr.error.error.message;
  if (anyErr?.message) return anyErr.message;
  return 'Something went wrong, please try again later';
}

export function mapAuthErrorMessage(err: unknown): string {
  const message = extractErrorMessage(err);
  switch (message) {
    case AuthErrors.emailAddressAlreadyExists:
      return 'Email Address Already Exists';
    case AuthErrors.badlyFormattedEmailAddress:
      return 'Email Address Badly Formatted';
    case AuthErrors.noPasswordSupplied:
      return 'No Password Supplied';
    case AuthErrors.invalidEmailOrPassword:
      return 'Invalid Email Or Password';
    case AuthErrors.userBlocked:
      return 'User blocked, please reset your password';
    case AuthErrors.invalidTwoFactorAuthCode:
      return 'Invalid Two Factor Authentication Code';
    case AuthErrors.emailAddressDoesNotExist:
      return 'Email Address Does Not Exist';
    case AuthErrors.invalidResetCode:
      return 'Invalid Reset Code';
    case AuthErrors.unexpectedError:
      return 'Unexpected error';
    default:
      return message;
  }
}
